/**
 * Реестр video-элементов участников.
 * VideoRenderer регистрирует свой <video>, остальной код читает ref без DOM-поиска.
 */

const videoElements = new Map<string, HTMLVideoElement>();
const listeners = new Set<() => void>();

const notify = () => {
    listeners.forEach((listener) => listener());
};

export const registerParticipantVideoElement = (participantId: string, element: HTMLVideoElement) => {
    if (!participantId) return;
    videoElements.set(participantId, element);
    notify();
};

export const unregisterParticipantVideoElement = (participantId: string, element?: HTMLVideoElement) => {
    if (!participantId) return;

    const current = videoElements.get(participantId);
    if (!current) return;
    if (element && current !== element) return;

    videoElements.delete(participantId);
    notify();
};

export const getParticipantVideoElement = (participantId: string): HTMLVideoElement | null => {
    if (!participantId) return null;
    return videoElements.get(participantId) ?? null;
};

export const subscribeParticipantVideoElements = (listener: () => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};
